import { createSlice } from "@reduxjs/toolkit";
import { TabType, ViewType } from "../components/CreateNoteModal/AITemplateModal/types";
import type { AppState } from "../types/index.type";

const initialState: AppState = {
  isCreateClientDrawerVisible: false,
  isCustomiseSectionVisible: false,
  selectedClient: null,
  uploadInProgress: false,
  isEditNote: false,
  isCreateModalVisible: false,
  isAITemplateModalVisible: false,
  isSubmissionInProgress: false,
  selectedNoteForEditing: null,
  isNotesViewVisible: false,
  uploadType: 0,
  showRecordingView: false,
  loadingNotes: true,
  currentPage: 1,
  isDemoPath: false,
  isMobilePath: false,
  openShare: false,
  showDemoSignupModal: false,
  addClientView: false,
  audioDevices: [],
  demoState: {
    isClientModalOpen: false,
    isNoteModalOpen: false,
    clientForm: null,
    recordingDetails: null,
  },
  templateOpenedFromNoteModal: false,
  storedTemplateData: null,
  customTemplateSelectedTab: TabType.LIST,
  templates: [],
  selectedView: ViewType.DASHBOARD,
  showRestrictionModal: false,
  showSettingsModal: false,
  shareClientModalVisible: false,
  shareClientModalClient: null,
  sidebarCollapsed: localStorage.getItem("sidebar-collapsed") === "true",
};

const appStateSlice = createSlice({
  name: "appState",
  initialState,
  reducers: {
    setCreateClientState: (state, action) => {
      state.isCreateClientDrawerVisible = action.payload;
    },
    setCustomiseSectionState: (state, action) => {
      state.isCustomiseSectionVisible = action.payload;
    },
    setSelectedClient: (state, action) => {
      state.selectedClient = action.payload;
    },
    setUploadProgressState: (state, action) => {
      state.uploadInProgress = action.payload;
    },
    setEditingState: (state, action) => {
      state.isEditNote = action.payload;
    },
    setCreateModalState: (state, action) => {
      state.isCreateModalVisible = action.payload;
    },
    setAITemplateModalState: (state, action) => {
      state.isAITemplateModalVisible = action.payload;
    },
    setSubmissionProgressState: (state, action) => {
      state.isSubmissionInProgress = action.payload;
    },
    setSelectedNoteForEditing: (state, action) => {
      state.selectedNoteForEditing = action.payload;
    },
    setNotesViewVisible: (state, action) => {
      state.isNotesViewVisible = action.payload;
    },
    setUploadType: (state, action) => {
      state.uploadType = action.payload;
    },
    setShowRecordingView: (state, action) => {
      state.showRecordingView = action.payload;
    },
    setLoadingNotesState: (state, action) => {
      state.loadingNotes = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setIsDemoPath: (state, action) => {
      state.isDemoPath = action.payload;
    },
    setShowDemoSignupModal: (state, action) => {
      state.showDemoSignupModal = action.payload;
    },
    clearAppState: (_state) => {
      _state = initialState;
    },
    setDemoState: (state, action) => {
      state.demoState = action.payload;
    },
    setAddClientView: (state, action) => {
      state.addClientView = action.payload;
    },
    setOpenShare: (state, action) => {
      state.openShare = action.payload;
    },
    setMobilePath: (state, action) => {
      state.isMobilePath = action.payload;
    },
    setAudioDevices: (state, action) => {
      state.audioDevices = action.payload;
    },
    setTemplateOpenedFromNoteModal: (state, action) => {
      state.templateOpenedFromNoteModal = action.payload;
    },
    setStoredTemplateData: (state, action) => {
      state.storedTemplateData = action.payload;
    },
    setCustomTemplateSelectedTab: (state, action) => {
      state.customTemplateSelectedTab = action.payload;
    },
    setAllTemplates: (state, action) => {
      state.templates = action.payload;
    },
    setSelectedView: (state, action) => {
      state.selectedView = action.payload;
    },
    setShowRestrictionModal: (state, action) => {
      state.showRestrictionModal = action.payload;
    },
    setShowSettingsModal: (state, action) => {
      state.showSettingsModal = action.payload;
    },
    setShareClientModalVisible: (state, action) => {
      state.shareClientModalVisible = action.payload;
    },
    setShareClientModalClient: (state, action) => {
      state.shareClientModalClient = action.payload;
    },
    setSidebarCollapsed: (state, action) => {
      state.sidebarCollapsed = action.payload;
      localStorage.setItem("sidebar-collapsed", String(action.payload));
    },
  },
});

export const {
  setCreateClientState,
  setCustomiseSectionState,
  setSelectedClient,
  setUploadProgressState,
  setEditingState,
  setCreateModalState,
  setAITemplateModalState,
  setSubmissionProgressState,
  setSelectedNoteForEditing,
  setNotesViewVisible,
  setUploadType,
  setOpenShare,
  setShowRecordingView,
  setLoadingNotesState,
  setCurrentPage,
  setIsDemoPath,
  setDemoState,
  setAddClientView,
  setShowDemoSignupModal,
  setMobilePath,
  setAudioDevices,
  setTemplateOpenedFromNoteModal,
  setStoredTemplateData,
  setCustomTemplateSelectedTab,
  setAllTemplates,
  setSelectedView,
  setShowRestrictionModal,
  setShowSettingsModal,
  setShareClientModalVisible,
  setShareClientModalClient,
  setSidebarCollapsed,
} = appStateSlice.actions;
export default appStateSlice.reducer;
